__turbopack_context__.v({
  "blogNavBar": "blognav-module__IZI1Wq__blogNavBar",
  "buttonLabel": "blognav-module__IZI1Wq__buttonLabel",
  "rightNavGroup": "blognav-module__IZI1Wq__rightNavGroup",
});
